// vendor modules
import React from "react"
import PropTypes from "prop-types"

import * as constants from "app/static/frontend/design-constants"

// components
import { SelectableSubheader, Icon } from "quorumdesign"
import Tooltip from "app/static/frontend/components/Tooltip"

import { useResponsiveSize } from "@/hooks"

export default function EnumGroupHeader(props) {
    const { isMobile } = useResponsiveSize()

    const areAllItemsSelected = props.enumValues.every((value) => props.deserializedValue.includes(value))

    const handleEnumGroupPress = () => {
        // behavior: makes all items in group active. If all items are active, deactivates them.
        let newValue
        if (areAllItemsSelected) {
            // deselects all items within group
            newValue = props.deserializedValue.filter((val) => !props.enumValues.includes(val))
        } else {
            // selects all the items in the group that aren't already selected
            newValue = props.enumValues.reduce(
                (checkedValues, item) => (!checkedValues.includes(item) ? [...checkedValues, item] : checkedValues),
                props.deserializedValue,
            )
        }

        props.publishChange(newValue)
    }

    const getIconType = () => {
        if (areAllItemsSelected) {
            return {
                // squareActive
                icon: "check-square",
                iconColor: constants.QuorumBlue,
                iconFamily: "fas",
            }
        }
        return {
            // default option: squareInactive
            icon: "square",
            iconColor: constants.HelpCenterSilverChalice,
            iconFamily: "far",
        }
    }

    const iconObj = getIconType()

    return props.shouldRenderSelectAll ? (
        <SelectableSubheader
            icon={iconObj.icon}
            iconColor={iconObj.iconColor}
            iconFamily={iconObj.iconFamily}
            isCollapsedGroup={props.isCollapsedGroup}
            isGroup
            onClick={handleEnumGroupPress}
            searchFilterTerm={props.searchFilterTerm}
            title={props.title}
        />
    ) : (
        <SelectableSubheader
            icon={iconObj.icon}
            iconColor={iconObj.iconColor}
            iconFamily={iconObj.iconFamily}
            isCollapsedGroup={props.isCollapsedGroup}
            onClick={() => {
                //do nothing
            }}
            searchFilterTerm={props.searchFilterTerm}
            title={props.title}
        >
            {!isMobile && props.groupHelpText && (
                <Tooltip label={props.groupHelpText} placement="top">
                    <div>
                        <Icon icon="info-circle" iconFamily="far" color={constants.QuorumGrey4} />
                    </div>
                </Tooltip>
            )}
        </SelectableSubheader>
    )
}

EnumGroupHeader.defaultProps = {
    isCollapsedGroup: false,
    shouldRenderSelectAll: true,
}

EnumGroupHeader.propTypes = {
    deserializedValue: PropTypes.arrayOf(PropTypes.number).isRequired,
    publishChange: PropTypes.func.isRequired,
    enumValues: PropTypes.arrayOf(PropTypes.number).isRequired,
    isCollapsedGroup: PropTypes.bool,
    // selected from the search => props.uniqueFlvId slice of the store
    searchFilterTerm: PropTypes.string,
    shouldRenderSelectAll: PropTypes.bool,
    title: PropTypes.string.isRequired,
}
